export class TokenRefreshError extends Error {
}
